import Tab from "bootstrap/js/dist/tab";

/**
 * Scroll the Al Shape and change the width of the scroll Bar according to its value.
 * Function called when we render the result page and when the page is resized (report/alest.html)
 */
function scrollAlShape() {
    // Constants
    const MIN_VALUE = 20;
    const NUMBER_STEP = 8;
    const WIDTH_RULER_SHAPE = 194;
    const OFFSET_NUMBER = WIDTH_RULER_SHAPE / NUMBER_STEP;
    // Get the 2 all-shape
    const allShapes = document.getElementsByClassName("all-shape");
    for (const allShape of allShapes) {
        // Get the constants and variables for each allShape
        const alShape = allShape.querySelector(".al-shape");
        const scrollBar = allShape.querySelector(".scroll-bar-ruler-shape");
        const endRuler = allShape.querySelector(".end-ruler-shape");
        const valueAlShape = alShape.querySelector(".value-al-shape");
        let { value } = valueAlShape.dataset;
        // Assigns min or max value according to the born (< or >)
        if (value.charAt(0) === "<") {
            value = 20;
        } else if (value.charAt(0) === ">") {
            value = 28;
            endRuler.style.display = "block"; // display the end of the scroll bar
        }
        // Calculate the translateX value of alShape
        const valueTranslated = (value - MIN_VALUE) * OFFSET_NUMBER;
        // Calculate the width value of scrollBar
        const valueWidthScroll =
            ((value - MIN_VALUE) * WIDTH_RULER_SHAPE) / NUMBER_STEP;
        // Scroll the al-shape according to its value;
        alShape.style.transform = "translateX(" + valueTranslated + "px)";
        // Change the width of the scrollBar ccording to its value;
        scrollBar.setAttribute("width", valueWidthScroll);
    }
}

/**
 * Show all tabs that starts with the same id.
 * @param {string} id
 */
function showLinkedTabs(id) {
    const triggerTabList = document.querySelectorAll(`[id^=${id}]`);

    triggerTabList.forEach((triggerEl) => {
        triggerEl.addEventListener("click", (event) =>
            onClickLinkedTab(event, triggerTabList)
        );
    });
}

/**
 * Handle click button tab
 * @param {Event} event
 * @param {HTMLElement[]} triggerTabList
 */
function onClickLinkedTab(event, triggerTabList) {
    event.preventDefault();

    triggerTabList.forEach((triggerEl) => {
        const tabTrigger = new Tab(triggerEl);
        tabTrigger.show();
    });
}

/**
 * Initialize linked tabs for a given list of ids.
 */
function triggerTabsById() {
    const tabButtonIds = ["model-eye-tab", "centile-chart-tab"];

    tabButtonIds.forEach((tabButtonId) => showLinkedTabs(tabButtonId));
}

// Execute the function on load
window.addEventListener("load", function () {
    scrollAlShape();
    triggerTabsById();
});
